import { SectionHeader } from '@/components/ui/SectionHeader'
import { IncludedGrid } from '@/components/ui/IncludedGrid'
import { included } from '@/data/work-with-me-content'

export const ProgrammeIncluded = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-5xl px-6">
      <SectionHeader title="What your" accent="programme includes" />
      <IncludedGrid items={included} />
    </div>
  </section>
)
